import React, {Component} from 'react'
import photo from '../img/s-tokariev.jpg'
import CodeEditor from '../components/CodeEditor'
import {Helmet} from "react-helmet";

class HomePage extends Component {
	componentWillMount() {
		document.body.className='home'
	}

	render() {
		return (
			<main>
				<Helmet>
					<title>Tokariev Sviatoslav's workshop</title>
				</Helmet>
				<h1 className="hidden">Tokariev Sviatoslav's workshop</h1>
				<div className="intro">
					<div className="intro__left">
						<div className="my-image">
							<img src={photo} alt="Sviatoslav Tokariev"/>
						</div>
						<header className="intro__left-header">
							<h2 className="heading--fullname">Sviatoslav Tokariev</h2>
							<h3 className="heading--pinkbg">
								WEB DEVELOPER
							</h3>
						</header>
						<section className="skills">
							<div className="command-line-wrapper">
								<h2 className="heading--blue">I'M PROFICIENT IN:</h2>
								<div className="command-line"><span id="command-line"></span></div>
							</div>
							<ul className="skills__list">
								<li className="skills__item">
									<span id="item--bootstrap">HTML5/CSS3 (Bootstrap, </span>
									<span id="item--sass">SASS/LESS, </span>
									<span id="item--bem">BEM, </span>
									<span id="item--accessibility">Accessibility)</span>
								</li>
								<li className="skills__item">
									<span id="item--es6">Javascript (ES6, </span>
									<span id="item--react">React, </span>
									<span id="item--node">NodeJS, </span>
									<span id="item--express">Express, </span>
									<span id="item--canvas">HTML5 Canvas)</span>
								</li>
								<li className="skills__item">
									<span id="item--php">PHP (OOP, </span>
									<span id="item--phpmvc">MVC, </span>
									<span id="item--pdo">PDO, </span>
									<span id="item--composer">Composer, </span>
									<span id="item--wordpress">Wordpress)</span>
								</li>
								<li className="skills__item">
									<span id="item--asp">C# (ASP.NET, </span>
									<span id="item--coop">OOP, </span>
									<span id="item--cmvc">MVC)</span>
								</li>
								<li className="skills__item">
									<span id="item--mysql">MySQL /</span>
									<span id="item--mssql">MSSQL /</span>
									<span id="item--oracle">Oracle /</span>
									<span id="item--mongo">MongoDB</span>
								</li>
							</ul>
						</section>
					</div>
					<CodeEditor/>
				</div>
				<section className="aboutme">
					<h2 className="heading--blue">ABOUT ME</h2>
					<p className="aboutme__text">I am a Toronto based developer passionate about computers.</p>
					<p className="aboutme__text">Programming makes me enjoy my time especially when after finishing one
						web application
						I can see how to enhance previous applications or create new ones.</p>
					<p className="aboutme__text">I also work in a freelance design/animation team called SKIF Production
						as a Web
						developer and Project Manager so feel free to contact me if you are interested in this kind of
						work.
					</p>
					<p className="aboutme__text">Thanks for passing by :)</p>
				</section>
				<div className="social">
					<h2 className="hidden">Social links</h2>
					<ul>
						<li className="social__link">
							<a href="https://github.com/svtokarevsv" target="_blank" rel="noopener noreferrer"
							   className="icon--github" title="Github" aria-label="Github link">
							</a>
						</li>
						<li className="social__link">
							<a href="https://www.facebook.com/svtokarevsv" target="_blank" rel="noopener noreferrer"
							   className="icon--facebook" title="Facebook"
							   aria-label="Facebook link">
							</a>
						</li>
						<li className="social__link">
							<a href="https://www.linkedin.com/in/tokarievsviatoslav/" target="_blank"
							   rel="noopener noreferrer" className="icon--linkedin" title="Linkedin"
							   aria-label="Linkedin link">
							</a>
						</li>
					</ul>
				</div>
			</main>
		)
	}

}

export default HomePage



// WEBPACK FOOTER //
// ./src/containers/HomePage.js